import ApiService from './api.service'

const TransactionService = {

	/**
	 * Save or update
	 * New transaction
	 * @param data
	 * @returns {*}
	 */
	createOrUpdate: function(data) {
		return ApiService.post(`/transaction/add-or-update`, data)
	},


	/**
	 * Get all or
	 * Search transactions
	 * @returns {*}
	 */
	search: function(data) {
		return ApiService.post(`/transaction/search`,data)
	},

	deleteTransaction: function (id) {
		return ApiService.delete(`/transaction/delete/${id}`)
	}

};

export default TransactionService;
